import React from 'react';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';

export const ServiceDeskNotificationEmailNextGenRedirect = ({ match }: RouteContext) => {
	const { projectKey } = match.params;

	const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/notification-email`;
	return <Redirect to={url} />;
};
